import React from 'react';
import {
  List,
  Datagrid,
  Create,
  SimpleForm,
  TextInput,
  TextField,
  LongTextInput,
  translate as t,
  Filter,
} from 'admin-on-rest';

import Edit from '../components/Edit';
import EditButton from '../components/button/EditButton';
import DeleteButton from '../components/button/DeleteButton';
import TranslatableInput from '../components/inputs/TranslatableInput';

const PhraseFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
  </Filter>
);


export const PhraseList = (props) => (
  <List
    {...props}
    perPage={25}
    filters={<PhraseFilter />}
  >
    <Datagrid>
      <TextField source="identifier" />
      <TextField source="platform" />
      <EditButton {...props} basePath="/phrases" />
      <DeleteButton {...props} basePath="/phrases" />
    </Datagrid>
  </List>
);

const PhraseTitle = t(({ record, translate }) => (
  <span>{record ? translate('edit.title', { title: record.identifier }) : ''}</span>
));

const Form = (props) => (
  <SimpleForm {...props}>
    <TextInput source="identifier" />
    <TextInput source="platform" />
    <TranslatableInput source="translations" />
    <LongTextInput source="notes" />
  </SimpleForm>
);

export const PhraseEdit = (props) => (
  <Edit title={<PhraseTitle />} {...props}>
    <Form />
  </Edit>
);

export const PhraseCreate = (props) => (
  <Create {...props}>
    <Form />
  </Create>
);
